<template>
  <footer class="clearfix">
    <div class="wrap white">
      <div class="pull-left">
        <ul class="clearfix ul-cls">
          <li>
            <a href="https://www.nxinsz.com/aboutus.html" target="_blank">关于农信数智</a>
<!--            <a href="https://nx.nxin.com/" target="_blank">关于农信数智</a>-->
          </li>
          <li>
            <a href="https://www.nxin.com/law.html" target="_blank">法律声明</a>
          </li>
          <li>
            <a href="https://www.nxinsz.com/news.html" target="_blank">最新活动</a>
          </li>
          <li>
            <a href="https://www.nxinsz.com/contactus.html" target="_blank">联系我们</a>
<!--            <a href="https://nx.nxin.com/aboutus.html" target="_blank">联系我们</a>-->
          </li>
          <li>
<!--            <a href="https://passport.nxin.com/home/agreement/50171" target="_blank">隐私政策</a>-->
            <a href="https://znt.com.cn/agreement" target="_blank">隐私政策</a>
          </li>
<!--          <li>-->
<!--            <a href="https://nx.nxin.com/recruitment.html" target="_blank">诚聘英才</a>-->
<!--          </li>-->
        </ul>
      </div>
      <div class="pull-left">
        <ul class="clearfix ul-cls">

          <li>
            <a href="https://passport.nxin.com/home/agreement/52900" target="_blank"
              >侵权投诉指引</a
            >
          </li>          <li>违法和不良信息举报邮箱：kefu@nxin.com

        </li>
        </ul>
        <div>
          <!-- eslint-disable-next-line -->
          农信数智科技股份有限公司 © 2013-{{ copyrightYear }} All Rights Reserved&nbsp;&nbsp;&nbsp;
        </div>
        <div>
          <!-- eslint-disable-next-line -->
          <a href="https://beian.miit.gov.cn" target="_blank" style="color: #fff">
            京ICP备13013445号 </a
          >&nbsp;&nbsp;&nbsp;
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802000105"
            target="_blank"
            style="color: #fff"
          >
            京公网安备11010802000105
          </a>
        </div>
      </div>
      <ul class="clearfix ul-cls pull-right">
<!--        <li class="pointer zhiCustomBtn">-->
<!--          <a-->
<!--            href="https://work.weixin.qq.com/kfid/kfcd664a576a4abadcc"-->
<!--            target="_blank"-->
<!--            style="color: #fff"-->
<!--          >-->
<!--            <svg-icon class="pull-left" icon-name="service" />在线客服-->
<!--          </a>-->
<!--        </li>-->
        <li v-if="!isZnt" class="pointer" @click="$parent.advice">
          客服邮箱：<span class="arial">kefu@nxin.com</span>
        </li>
        <li class="tel-400">热线：<span class="arial">400-810-5353</span></li>
      </ul>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import isInZnt from '@/utils/znt.js';

export default {
  data() {
    return {
      copyrightYear: new Date().getFullYear(),
      isZnt: isInZnt(),
    };
  },
};
</script>
